import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import LoanPrograms from "@/pages/LoanPrograms";
import MortgageCalculator from "@/pages/MortgageCalculator";
import ApplyNow from "@/pages/ApplyNow";
import Resources from "@/pages/Resources";
import ResourceDetail from "@/pages/ResourceDetail";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import Pulse from "@/pages/Pulse";
import Schedule from "@/pages/Schedule";
import Ecosystem from "@/pages/Ecosystem";
import Demo from "@/pages/Demo";
import LandingPage from "@/pages/LandingPage";
import Portal from "@/pages/Portal";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import AuthCallback from "@/pages/AuthCallback";
import ComingSoon, { isGateUnlocked } from "@/pages/ComingSoon";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

// Paths that always bypass the Coming Soon gate (shareable client previews + admin)
const GATE_BYPASS_PATHS = ["/ecosystem", "/demo", "/lp", "/admin", "/portal", "/pulse", "/schedule"];

const pathBypassesGate = () => {
  if (typeof window === "undefined") return false;
  const p = window.location.pathname || "";
  return GATE_BYPASS_PATHS.some((b) => p === b || p.startsWith(b + "/"));
};

/** Detect Google OAuth callback synchronously (URL fragment can appear on ANY route). */
function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/ecosystem" element={<Ecosystem />} />
      <Route path="/demo" element={<Demo />} />
      <Route path="/lp/:slug" element={<LandingPage />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/pulse" element={<Pulse />} />
      <Route path="/schedule" element={<Schedule />} />
      <Route
        path="/portal"
        element={
          <ProtectedRoute>
            <Portal />
          </ProtectedRoute>
        }
      />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />

      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/loan-programs" element={<LoanPrograms />} />
        <Route path="/calculator" element={<MortgageCalculator />} />
        <Route
          path="/apply"
          element={
            <ProtectedRoute>
              <ApplyNow />
            </ProtectedRoute>
          }
        />
        <Route path="/resources" element={<Resources />} />
        <Route path="/resources/:slug" element={<ResourceDetail />} />
        <Route path="/contact" element={<Contact />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  const [unlocked, setUnlocked] = useState(() => isGateUnlocked() || pathBypassesGate());

  if (!unlocked) {
    return (
      <div className="App">
        <ComingSoon onUnlock={() => setUnlocked(true)} />
        <Toaster position="top-right" />
      </div>
    );
  }

  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}
